export default "__VITE_ASSET__CT_pRWE3__"